var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","flat":true,"height":51,"color":"#FFF"}},[_c('div',{staticClass:"logo-div"},[_c('img',{attrs:{"src":_vm.imgSrc,"height":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }